/**
 * The rules the server holds a password to (`add-user.schema.ts` on the backend), each a line of
 * the list under the field. A symbol is one of those the server counts, nothing else.
 */
export const passwordRules = [
  { label: 'User_Password_Rule_Length', test: (password: string) => password.length >= 8 },
  { label: 'User_Password_Rule_Case', test: (password: string) => /[A-Z]/.test(password) && /[a-z]/.test(password) },
  {
    label: 'User_Password_Rule_NumberOrSymbol',
    test: (password: string) => /[0-9]/.test(password) || /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password),
  },
];
